import React from "react";
import { useTheme } from "styled-components";

import { SERVICE_TYPE } from "@typings/globals";

import {
  HomeHouseLine,
  BaggageBags,
  ModernBuilding4,
} from "@ui/Assets/MyIcons";
import { TestWrapper } from "@ui/Atoms/TestWrapper";

import { useTranslate } from "@hooks/useTranslate";
import { useTelemetry } from "@hooks/useTelemetry";

import * as Styled from "./StartBooking.styled";

const icons: Record<SERVICE_TYPE, typeof HomeHouseLine> = {
  [SERVICE_TYPE.HOME_CLEANING]: HomeHouseLine,
  [SERVICE_TYPE.END_OF_TENANCY]: BaggageBags,
  [SERVICE_TYPE.B2B]: ModernBuilding4,
};

const labels: Record<SERVICE_TYPE, string> = {
  [SERVICE_TYPE.HOME_CLEANING]: "service_type_b2c",
  [SERVICE_TYPE.END_OF_TENANCY]: "service_type_eot",
  [SERVICE_TYPE.B2B]: "service_type_b2b",
};

const testIds: Record<SERVICE_TYPE, string> = {
  [SERVICE_TYPE.HOME_CLEANING]: "serviceTypeSelectorHomeCleaning",
  [SERVICE_TYPE.END_OF_TENANCY]: "serviceTypeSelectorEndOfTenancy",
  [SERVICE_TYPE.B2B]: "serviceTypeSelectorB2B",
};

interface Props {
  serviceType: SERVICE_TYPE;
  selected: boolean;
  onClick: (serviceType: SERVICE_TYPE) => void;
}

export const CleaningSelectorItem: React.FC<Props> = props => {
  const theme = useTheme();
  const translate = useTranslate("batmaid_pwa_generic");
  const { elementClick } = useTelemetry();

  const Icon = icons[props.serviceType];
  const testId = testIds[props.serviceType];
  const label = translate(labels[props.serviceType]);

  const clickHandler = () => {
    elementClick(label, {
      buttonId: "select_service_type_button",
      context: {
        serviceType: props.serviceType,
      },
    });

    props.onClick(props.serviceType);
  };

  return (
    <TestWrapper testId={testId}>
      <Styled.CleaningSelectorItem>
        <Styled.CleaningTypeButton
          selected={props.selected}
          onClick={clickHandler}
        >
          <Styled.CleaningTypeIcon>
            <Icon width={theme.icons.sizes.base_x3} />
          </Styled.CleaningTypeIcon>

          <Styled.CleaningTypeButtonLabel selected={props.selected}>
            {label}
          </Styled.CleaningTypeButtonLabel>
        </Styled.CleaningTypeButton>
      </Styled.CleaningSelectorItem>
    </TestWrapper>
  );
};
